import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import Style from './Simple.cssmodule.less';
import { clickButton } from '../../actions/Modal';
import Title from '../CommonSet/Title';

class Simple extends BaseComponent {
    constructor(props) {
        super(props);
        this.setConfirmTheme(props.theme);
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
        });
    }

    setConfirmTheme(theme) {
        const themeStyle = this.getTheme(theme, 'SIMPLE');
        this.Style = themeStyle || Style;
    }

    createHtmlContent(contnet) {
        let contentHTML = '';

        if (contnet) {
            contentHTML = contnet.replace(/\*\*\*.*?\*\*\*/gim, (item) => {
                let block = item.substring(3, item.lastIndexOf('***'));
                return $('<div>')
                    .append(this.createRenderView(block))
                    .html();
            });
        }

        return contentHTML;
    }

    createContent() {
        let view = null;

        if (this.props.item.content) {
            view = (
                <div className={this.Style.content}>
                    <div dangerouslySetInnerHTML={{
                        __html: this.createHtmlContent(this.props.item.content),
                    }}
                    />
                </div>
            );
        }

        return view;
    }

    render() {
        return (
            <div className={this.Style.SimpleModal}>
                <Title
                    className={this.Style.title}
                    isClose
                    onClose={() => this.handleButtonClick('close')}
                >
                    {this.props.item.title}
                </Title>

                <div className={this.Style.contentView}>
                    {this.createContent()}
                </div>
            </div>
        );
    }
}

Simple.displayName = 'Simple';
Simple.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    undefined,
    mapDispatchToProps,
)(Simple);



// WEBPACK FOOTER //
// ./components/ModalSet/Simple.js